import { Component, OnInit } from '@angular/core';

@Component({
  template: '<div>Learn More</div>'
})
export class LearnMoreComponent {
}
